import React from 'react';
import ReactDOM from 'react-dom';
import './index.css?v=1.2';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
